import { getRandomInt } from '@/utilities';

export default class Task {
  constructor({
    product,
    parentTask,
  }) {
    this.product = product;
    this.remainingTime = this.getBaseTime();
    this.parentTask = parentTask;
    this.subTasks = [];
    this.hadMeeting = false;
    this.assignee = undefined;
    this.efficiency = 1;
  }

  get isFinished() {
    return this.remainingTime <= 0;
  }

  get progress() {
    if (this.subTasks.length === 0) {
      return 0;
    }
    return this.subTasks.reduce((acc, task) => acc + task.progress, 0) / this.subTasks.length;
  }

  get subtaskHasBug() {
    if (this.subTasks.length === 0) {
      return 0;
    }
    return this.subTasks.reduce((acc, task) => acc + task.subtaskHasBug, 0) / this.subTasks.length;
  }

  get relatedEmployees() {
    const list = [];
    let task = this;
    while (task.parentTask) {
      task = task.parentTask;
      list.push(task.assignee);
    }
    return list;
  }

  // eslint-disable-next-line class-methods-use-this
  getBaseTime() {
    return 0;
  }

  update(productivity) {
    this.updateRemainingTime(productivity * this.efficiency);
  }

  updateRemainingTime(productivity) {
    this.remainingTime -= productivity;
  }

  setAssignee(employee) {
    this.assignee = employee;
  }

  reduceEfficiency() {
    this.efficiency = getRandomInt(1, 100) / 100;
  }

  setNormalEfficiency() {
    this.efficiency = 1;
  }

  generateTasks({
    TypeClass,
    product,
    count,
    hasSpec,
  }) {
    const tasks = [];
    for (let i = 0; i < count; i += 1) {
      tasks.push(new TypeClass({
        product,
        hasSpec,
        parentTask: this,
      }));
    }
    this.subTasks = tasks;
    return tasks;
  }
}
